<ngx-select [allowClear]="false" [items]="items" optionValueField="value" optionTextField="name"
    [disabled]="ngxDisabled" [(ngModel)]="zoneDashboard" placeholder="Total" (select)="changeMarket($event)"
    appendTo="body" dropDownMenuOtherClasses="zone">

    <ng-template ngx-select-option-not-found let-input>
        "{{input}}" no encontrado
    </ng-template>

</ngx-select>